export class Permissions {
    Name: string;

    static mapFromJSON(json) {
        const p = new Permissions();

        p.Name = json.name;

        return p;
    }
}